import type { ContractIntelligenceEditDiff } from "@/types/contractIntelligence.types";

export function inferEditDiff(prompt: string): ContractIntelligenceEditDiff | null {
  if (/5\.1|master.*ownership|perpetuity/i.test(prompt)) {
    return {
      section: "§5.1",
      title: "Ownership of Masters",
      before: "All Masters created during the Initial Term shall be owned by Label in perpetuity throughout the universe.",
      after:
        "All Masters created during the Initial Term shall be owned by Label, with ownership reverting to Artist seven (7) years following the end of the Initial Term.",
    };
  }
  if (/backend|6\.1|3.*5/i.test(prompt)) {
    return {
      section: "§6.1",
      title: "Backend Royalty",
      before: "a Backend Royalty of three percent (3%) of Gross Receipts.",
      after: "a Backend Royalty of five percent (5%) of Gross Receipts.",
    };
  }
  if (/cross.?collat|4\.3/i.test(prompt)) {
    return {
      section: "§4.3",
      title: "Recoupment",
      before:
        "Recoupment shall be cross-collateralized across all albums delivered during the Initial Term and any exercised Options.",
      after: "Recoupment shall be calculated on a per-album basis.",
    };
  }
  if (/touring|7\.2|15|10/i.test(prompt)) {
    return {
      section: "§7.2",
      title: "Touring Revenue",
      before: "Label shall be entitled to fifteen percent (15%) of net touring revenue during the Initial Term.",
      after: "Label shall be entitled to ten percent (10%) of net touring revenue during the Initial Term.",
    };
  }
  return null;
}

export function mockAiReply(prompt: string, hasDiff: boolean): string {
  if (hasDiff) {
    return "I've drafted a redline that moves this clause closer to market. The proposed language preserves Label's exploitation window while giving your client a realistic path to reversion. Review the diff below and accept if you're aligned.";
  }
  return `Good question on "${prompt.slice(0, 40)}${prompt.length > 40 ? "…" : ""}". I'd focus on §5.1 and §4.3 first — those are the highest-leverage pushes in this draft. Want me to draft specific language?`;
}

export const CONTRACT_HIGHLIGHTS = [
  { text: "$420,000", color: "#22c55e" },
  { text: "eighteen percent (18%)", color: "#4d6af5" },
  { text: "three percent (3%)", color: "#f59e0b" },
  { text: "in perpetuity throughout the universe", color: "#ef4444" },
  { text: "cross-collateralized", color: "#ef4444" },
  { text: "twelve (12) commercially satisfactory Masters", color: "#8b5cf6" },
  { text: "fifteen percent (15%)", color: "#f59e0b" },
];
